import { DEFAULT_IMAGE_SIZE } from '../../../constants';

export const replaceImageSize = (url) => {
  if (!url) return url;
  return url.replace(/<SIZE>/g, DEFAULT_IMAGE_SIZE);
};

export const getProductInfo = (product) => {
  const { itemId, identifiers, media, taxonomy } = product || {};
  const { canonicalUrl, productLabel, brandName } = identifiers || {};
  const { brandLinkUrl } = taxonomy || {};
  const { images } = media || {};
  const defaultImageView = images?.[0];
  const imageUrl = defaultImageView?.url ? replaceImageSize(defaultImageView.url) : undefined;

  return {
    itemId,
    canonicalUrl,
    productLabel,
    brandName,
    imageUrl,
    brandLinkUrl,
  };
};